<template>
    <component :is="layout">
        <router-view/>
    </component>
    <ConfirmModal />
</template>

<script>
import EventBus from "./common/EventBus";
import ConfirmModal from "./components/composant/ConfirmModal.vue";

export default {
    components: {
        ConfirmModal
    },
    computed: {
        layout() {
            return `${this.$route.meta.layout || 'default'}-layout`;
        }
    },
    mounted() {
        EventBus.on("logout", () => {
            this.router.push({ name: 'Logout'})
        });
    },
    beforeUnmount() {
        EventBus.remove("logout");
    }
};
</script>

<style lang="scss">

</style>
